import axiosInstance from "../../../api/config/axiosConfig";

const getAuthHeaders = () => {
  const token = localStorage.getItem("shelLoginToken");
  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
};

export const getCarList = (page = 1, pageSize = 50, search = "") => {
  const searchParam = search ? `&search=${encodeURIComponent(search)}` : "";
  return axiosInstance.get(
    `/admin/car/list?page=${page}&pageSize=${pageSize}${searchParam}`,
    { headers: getAuthHeaders() }
  );
};

export const getCarById = (uuid) => {
  return axiosInstance.get(`/admin/car/${uuid}`, {
    headers: getAuthHeaders(),
  });
};

export const createCar = (body) => {
  return axiosInstance.post(`/admin/car`, body, {
    headers: getAuthHeaders(),
  });
};

export const updateCar = (uuid, body) => {
  return axiosInstance.put(`/admin/car/${uuid}`, body, {
    headers: getAuthHeaders(),
  });
};

export const deleteCar = (uuid) => {
  return axiosInstance.delete(`/admin/car/${uuid}`, {
    headers: getAuthHeaders(),
  });
};

export const updateCarImages = (uuid, images) => {
  return axiosInstance.post(
    `/admin/car/${uuid}/images`,
    { images },
    { headers: getAuthHeaders() }
  );
};
